var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "nav search-menu-item" }, [
    _c("div", { attrs: { "data-testid": "globalsearch-section-area-name" } }, [
      _c(
        "a",
        {
          staticClass: "search-menu-item__header",
          attrs: {
            "data-testid": "globalsearch-section-link",
            target: "_blank",
            href: _vm.ultimateSearchLink
          },
          on: { click: _vm.handleClick }
        },
        [_vm._v(_vm._s(_vm.globalSearchSection.areaName))]
      )
    ]),
    _c(
      "ul",
      { attrs: { "data-testid": "globalsearch-section-area-items" } },
      _vm._l(_vm.globalSearchSection.items, function(item) {
        return _c(
          "li",
          { key: item.link, staticClass: "search-menu-item__result-item" },
          [
            _c(
              "a",
              {
                staticClass: "search-menu-item__result-item-link",
                attrs: {
                  "data-testid": "globalsearch-section-result-link",
                  target: "_blank",
                  href: item.link
                },
                on: { click: _vm.handleClick }
              },
              [
                _c("div", [_vm._v(_vm._s(item.description))]),
                item.companyName && item.sourceCompanyNumber
                  ? _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(item.companyName) +
                          " - (" +
                          _vm._s(item.sourceCompanyNumber) +
                          ") "
                      )
                    ])
                  : _vm._e(),
                item.vehicle
                  ? _c("VueGlobalSearchSectionVehicle", {
                      attrs: { globalSearchSectionVehicle: item.vehicle }
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }